/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsListParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
    limit: zod.number().optional(),
    order: zod.string().optional(),
    page: zod.number().optional(),
});

export type ApiAccountsListParams = zod.input<typeof ApiAccountsListParams>;
export type ApiAccountsListParamsOutput = zod.output<
    typeof ApiAccountsListParams
>;
